/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import {
  Grid,
  Menu,
  MenuItem,
  IconButton,
  Avatar,
  Hidden,
} from "@material-ui/core";

import { makeStyles } from "@material-ui/core/styles";

import { KeyboardArrowDown } from "@material-ui/icons";

import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";

import ToastModal from "views/components/ToastModal";

import brandTheme from "brandTheme/Theme";

import {
  saveAuthData,
  saveUserData,
  saveUserLeadId,
} from "store/reducers/login/LoginSlice";

import ProfileIcon from "../../../assets/img/ProfileIcon.svg";
import { saveUserProfileInfo } from "store/reducers/login/LoginSlice";

const useStyles = makeStyles((theme) => ({
  headerContainer: {
    justifyContent: "flex-end",
    display: "flex",
    width: "100%",
  },

  rightSection: {
    display: "flex",
    alignItems: "center",
    marginRight: "10px",
    gap: "15px",

    [theme.breakpoints.down("sm")]: {
      gap: "5px",
      marginRight: 0,
    },
  },

  dateText: {
    fontWeight: 400,
    fontSize: "14px",
    color: brandTheme.black,

    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },

  divider: {
    height: "24px",
    width: "1px",
    backgroundColor: "#ccc",

    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },

  avatar: {
    width: 45,
    height: 45,
    backgroundColor: brandTheme.primary,
    color: "#fff",

    [theme.breakpoints.down("sm")]: {
      width: 28,
      height: 28,
    },
  },

  button: {
    backgroundColor: "transparent",
    color: brandTheme.black,
    boxShadow: "none",
    padding: "4px 8px",

    "&:hover": {
      backgroundColor: "transparent",
      boxShadow: "none",
    },

    "&:focus": {
      backgroundColor: "transparent",
      boxShadow: "none",
    },
  },

  arrowIcon: {
    [theme.breakpoints.down("sm")]: {
      fontSize: "18px",
    },
  },
}));

const DesktopHeader = ({ mobileView }) => {
  const classes = useStyles();

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [openProfile, setOpenProfile] = useState(null);

  const { authToken } = useSelector(
    (state) => state.login.authData
  );
  const { userProfileInfo } = useSelector((state) => state.login);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] =
    useState("");

  const navigateToLoginPage = async () => {
    const result = await apiHandler({
      url: endpoint.APP_URL,
      authToken,
    });

    if (result.data && result.data.main) {
      window.location.href = result.data.main;
    }
  };

  useEffect(() => {
    function storageChange(event) {
      if (event.key === "persist:root") {
        const { login } = JSON.parse(event.newValue);
        const { authData } = JSON.parse(login);

        if (authData && !authData.isAuthenticated) {
          navigateToLoginPage();
        }
      }
    }

    window.addEventListener(
      "storage",
      storageChange,
      false
    );

    return function cleanup() {
      window.removeEventListener(
        "storage",
        storageChange
      );
    };
  }, []);

  const handleCloseProfile = () => {
    setOpenProfile(null);
  };

  const formatDate = () => {
    let nDate = new Date().getDate();
    nDate = nDate < 10 ? "0" + nDate : nDate;

    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const nMonth =
      monthNames[new Date().getMonth()];

    return `${nDate}-${nMonth}-${new Date().getFullYear()}`;
  };

  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };

  const handlelogout = async () => {
    await apiHandler({
      url: endpoint.LOGOUT,
      authToken,
    });

    sessionStorage.removeItem("persist:root");
    sessionStorage.removeItem("RepaymentFlag");
    dispatch(
      saveAuthData({
        authToken: null,
        refreshToken: null,
        tokenTime: "",
        isAuthenticated: false,
      })
    );

    dispatch(
      saveUserData({
        role: "",
        email: "",
        username: "",
        name: "",
        mobileNumber: "",
      })
    );
    dispatch(
      saveUserLeadId({
        leadId: "",
        leadStatus: "",
      })
    );

    dispatch(
      saveUserProfileInfo({})
    );
    navigate("login");
  };
  console.log(userProfileInfo?.[0]?.photo,"flfksjdhf")
  const handleMenuItemClick = (value) => {
    if (value === "profile") {
      navigate("/profileDetails");
    }
    if (value === "UpdatePanDetails") {
      navigate("/UpdatePanDetails");
    }
    if (value === "logOut") {
      handlelogout();
    }
  };
  return (
    <Grid container className={classes.headerContainer}>
      <Grid item className={classes.rightSection}>
        {!mobileView && (
          <>
            <span className={classes.dateText}>
              {formatDate()}
            </span>

            <div className={classes.divider} />
        <IconButton
          onClick={(e) =>
            setOpenProfile(e.currentTarget)
          }
          className={classes.button}
        >
          <Avatar
            alt="User"
            src={userProfileInfo?.[0]?.photo || ProfileIcon}
            className={classes.avatar}
          />

          <KeyboardArrowDown
            className={classes.arrowIcon}
          />
        </IconButton>
            </>
        )}
        <Menu
          anchorEl={openProfile}
          open={Boolean(openProfile)}
          onClose={handleCloseProfile}
          getContentAnchorEl={null}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
        >
          <MenuItem
            onClick={() =>
              handleMenuItemClick("profile")
            }
          >
            View Profile
          </MenuItem>

          <MenuItem
            onClick={() =>
              handleMenuItemClick("UpdatePanDetails")
            }
          >
            PAN Details
          </MenuItem>

          <MenuItem
            onClick={() =>
              handleMenuItemClick("logOut")
            }
          >
            Logout
          </MenuItem>
        </Menu>
      </Grid>

      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}
    </Grid>
  );
};

DesktopHeader.propTypes = {
  mobileView: PropTypes.bool,
};

DesktopHeader.defaultProps = {
  mobileView: false,
};

export default DesktopHeader;